// Mirrors the :root --tls-* tokens in app/globals.css. 2026-08-14 owner
// ruling: grounds / tints / ink come from the LockSound Design System
// (ground-0/1/2/inset = canvas/surface/surfaceElevated/canvasSoft; ink ladder
// = textStrong/textMuted/textSubtle). Keep both objects in sync with the CSS.
export const DESIGN_THEME_DARK = {
  canvas: "#0e1013",
  canvasSoft: "#212630",
  surface: "#15181c",
  surfaceElevated: "#1a1e23",
  surfaceHover: "#171a1f",
  heroBg: "#1a1e23",
  heroFg: "#f4f5f7",
  heroMuted: "#c5c9d0",
  heroEdge: "#24282e",
  heroAccent: "#7b9bf7",
  heroAccentForeground: "#14161a",
  heroFocus: "#7b9bf7",
  heroSignal: "#7b9bf7",
  heroWaveIdle: "rgba(244,245,247,0.28)",
  textStrong: "#f4f5f7",
  textMuted: "#c5c9d0",
  textSubtle: "#a2a8b0",
  accent: "#2f56d8",
  accentForeground: "#f7f8fb",
  danger: "#ef4444",
  warning: "#f59e0b",
  borderSubtle: "#24282e",
  borderStrong: "#2c3138",
  // RGB triplets for canvas/2D contexts that need to compose colors with alpha
  brandRgbTriplet: "47, 86, 216",
  irisRgbTriplet: "47, 86, 216",
  mintRgbTriplet: "47, 86, 216",
  // Light-fg overlay used for faint canvas grids (= textStrong #f4f5f7)
  fgLightRgbTriplet: "244, 245, 247",
} as const;

// Mirrors the `.light` overrides in app/globals.css (unlayered .light block).
// Canvas/OG contexts (e.g. <canvas>-painting waveforms)
// can't resolve CSS custom properties, so JS-side consumers that need to
// react to the active theme should pick between DESIGN_THEME_DARK and this
// object based on whether `.light` is present on <html>.
export const DESIGN_THEME_LIGHT = {
  canvas: "#ffffff",
  canvasSoft: "#dcdee1",
  surface: "#f2f2f2",
  surfaceElevated: "#e9eaec",
  surfaceHover: "#f7f7f7",
  heroBg: "#f2f2f2",
  heroFg: "#14161a",
  heroMuted: "#4a4d52",
  heroEdge: "#dcdde0",
  heroAccent: "#1e46c8",
  heroAccentForeground: "#ffffff",
  heroFocus: "#1e46c8",
  heroSignal: "#1e46c8",
  heroWaveIdle: "rgba(20,22,26,0.28)",
  textStrong: "#14161a",
  textMuted: "#4a4d52",
  textSubtle: "#5c6066",
  accent: "#1e46c8",
  accentForeground: "#ffffff",
  danger: "#b92e2e",
  warning: "#7a5008",
  borderSubtle: "#dcdde0",
  borderStrong: "#c2c4c8",
  // RGB triplets for canvas/2D contexts that need to compose colors with alpha
  brandRgbTriplet: "30, 70, 200",
  irisRgbTriplet: "30, 70, 200",
  mintRgbTriplet: "30, 70, 200",
  // Dark-fg overlay used for faint canvas grids on a light canvas (= ink #14161a)
  fgLightRgbTriplet: "20, 22, 26",
} as const;

export type DesignTheme = Record<keyof typeof DESIGN_THEME_DARK, string>;
